/**************************************************************************************************
 *
 *  This is the main container for all project related views: Project Detail (hierarch), Project
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
**************************************************************************************************/

import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import dataModel from '../../models/DataModel';
import mobileBridge from '../../helpers/MobileBridge';
import Home from '../../containers/Home';
import BasePage from '../../baseClasses/BasePage';
import Header from '../../components/Header';
import ErrorPage from '../ErrorPage';
import PORNav from './PORNav';

import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import { location_shallow } from '../../dao/collections/LocationsCollection';

import addIcon from '../../assets/images/add-icon-gray.svg';
import locationIcon from '../../assets/images/locations-icon-light-gray.svg';
import companyIcon from '../../assets/images/companies-icon-light-gray.svg';
import './PORContainer.scss';
import CollectionDataSource from '../../dao/DataSource/CollectionDataSource';

export class PORContainer extends BasePage {

  constructor(props) {
    super(props);

    this.state = {
      view: null,
      resetScroll: false,
    };

    this.mounted = false;
  }

  handleLocationsRetrieval(navigationLocations, action, acData, fetchedData) {
    this.setState({ locations: navigationLocations.locations });
  }

  handleFinishInitialization(fromMount) {
    const { currentUser, currentCompany } = this.props;
    if (!currentCompany || !currentUser) {
      return null;
    }
      
  }

  componentDidMount() {
    super.componentDidMount();
    const currentRole = dataModel.usersDAO.currentUser ? dataModel.usersDAO.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });

    this.mounted = true;

    // This is only to see if there are any locations (it only needs to get 1 record)
    this.locationsDataSource = new CollectionDataSource('LocationsCollection', 'Location', location_shallow, this.handleLocationsRetrieval, 'locationsCount', 1, null, null, this.props.currentCompany.id, 'locations', null, location_shallow);
    this.locationsDataSource.searchString = '';
    this.locationsDataSource.current();
  }

  componentWillUnmount() {
    this.mounted = false;
    if (this.locationsDataSource) {
      this.locationsDataSource.release();
      this.locationsDataSource = null;
    }
  }

  getSystemPopupView() {
    if (this.props.systemPopup) {
      return this.props.systemPopup;
    }
    else {
      return null;
    }
  }

  render() {
    if (!mobileBridge) {
      return null;
    }
    else if (mobileBridge.isMobile) {
      return null;
    }
    if (this.props.catastrophicError) {
      return <ErrorPage catastrophicError={this.props.catastrophicError} />;
    }
    let waitSpinner = null;
    if (this.props.inProgress) {
      waitSpinner = <Home type="transparent" />;
    } 
    if (!dataModel.textMap) {
      dataModel.textMap = this.textMap;
    }
    if (!this.props.currentUser || !this.props.currentCompany || !this.props.permissions) {
      return <Home type={'locations'} message={'Awaiting Initialization'} />;
    }

    if (!this.props.permissions.canViewPOR) {
      return null;
    }
    this.setWhiteLabels(this.props.currentCompany);

    if (!this.state.locations) {
      return <Home timeout={120000} type={'locations'} message={'LOADING PLAN OF RECORD'} />;
    }

    const { 
      locations,
    } = this.state;

    let view = null;

    if (this.props.permissions && this.props.currentCompany.admin_company) {
      view = <div className="plan-of-record" id={this.props.id}>
        <div className='no-plan-of-record-container'>
          <img className='plan-of-record-icon' src={companyIcon} alt='icon' />
          <div className="no-plan-of-record">To edit/view locations you must first select a company.</div>
        </div>
      </div>;
    }
    else if (!locations || !locations.length) {
      let noPORText = <div className="no-plan-of-record">There are no locations created yet for this company.</div>;
      if (this.props.permissions.canCreateLocation) {
        noPORText = <div className="no-plan-of-record">There are no locations created yet for this company. <br />Select <img alt='button' className='add-button' src={addIcon} onClick={this.navComponent ? this.navComponent.wrappedInstance.handleDisplayAddCard : null} /> to add a location.</div>;
      }
      view = <div className="plan-of-record" id={this.props.id}>
        <div className='no-plan-of-record-container'>
          <img className='location-icon' src={locationIcon} alt='icon' />
          {noPORText}
        </div>
      </div>;
    }

    const path = this.props.history.parseParameters();
    
    // UPDATE SQUASH ///
    const PORNavigator = 
      <PORNav /*ref={component => {this.navComponent = component}}*/
        resetScroll={this.state.resetScroll} params={path.params}
        viewName={path.params.edit ? 'locationCRUD' : ''} 
      />;
    const systemPopup = this.getSystemPopupView();

    return (
      <div className="plan-of-record-container"
        ref={(element) => { this.mainContainer = element; }}>
        {systemPopup}
        {waitSpinner}
        <div className='main-header'>
        <Header selectedPage={'POR'} />
        </div>
        <div className="plan-of-record-body">
          <div className={'plan-of-record-nav-container'}>
            {PORNavigator}
          </div>
          <div className="plan-of-record-detail-container" id="plan-of-record-detail-container" >
          {view ||
            <Router history={this.props.history}>
              <Switch>
                {
                  this.props.routes.map((route, i) => (
                    <Route
                      key={route.component.displayName ? route.component.displayName : route.component.name}
                      path={route.path}
                      render={props => {
                        let routeProps = { ...props };
                        routeProps.params = path.params;
                        routeProps.id = path;
                        routeProps.key = path;
                        routeProps.history = this.props.history;
                        if (path.params.location_id && path.params.edit) {
                          routeProps.isDialog = true;
                        }
                        return (
                          <route.component {...routeProps} routes={route.routes} />
                        );
                      }
                      }
                    />
                  )
                  )
                }
              </Switch>
            </Router>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    catastrophicError: state.main.catastrophicError,
    inProgress: state.main.inProgress,
    permissions: state.new_users ? state.new_users.permissions : null,
    systemPopup: state.main.systemPopup,
    currentUser: state.new_users.currentUser,
    passthroughUri: state.main.passthroughUri,
    currentCompany: state.new_companies.currentCompany,
    needsLogin: state.main ? state.main.needsLogin : null,
    dataChanged: state.main.dataChanged,
  };
};

export default withRouter(connect(mapStateToProps)(PORContainer));



// WEBPACK FOOTER //
// ./src/containers/PORContainer/index.js